// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.radio-button {
  display: flex;
}
.radio-button__checkmark {
  background: red;
}
.radio-button input[type=radio] {
  display: grid;
  place-content: center;
  accent-color: #333333;
}
.radio-button input[type=radio]::before {
  content: "";
  width: 20px;
  height: 20px;
}
.radio-button__itemText {
  display: flex;
  margin-left: 5px;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/common/radio/radio.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;AACJ;AACI;EACI,eAAA;AACR;AAEI;EACI,aAAA;EACA,qBAAA;EACA,qBAAA;AAAR;AAGM;EACE,WAAA;EACA,WAAA;EACA,YAAA;AADR;AAII;EACE,aAAA;EACC,gBAAA;EACA,mBAAA;AAFP","sourcesContent":[".radio-button {\n    display: flex;\n\n    &__checkmark {\n        background: red;\n    }\n\n    input[type=\"radio\"] {\n        display: grid;\n        place-content: center;\n        accent-color: #333333;\n      }\n      \n      input[type=\"radio\"]::before {\n        content: \"\";\n        width: 20px;\n        height: 20px;\n      }\n\n    &__itemText {\n      display: flex;\n       margin-left: 5px;\n       align-items: center;\n    }\n      \n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
